import { Component, OnInit, inject, signal } from '@angular/core';
import { ResultService } from '@ukam/core/services/result.service';
import { AppFileExplorerComponent, ExplorerStorage } from '@ukam/ui-kit/files/file-explorer/file-explorer.component';
import { StorageApiService } from '../storages/services/storage-api.service';

/**
 * Gestão de arquivos (StoredFile/StoredFolder) em todos os discos (Storage) cadastrados,
 * usando o mesmo explorador reutilizável embutido nos cadastros (app-file-explorer).
 */
@Component({
  selector: 'app-stored-file-manager',
  templateUrl: './stored-file-manager.component.html',
  imports: [AppFileExplorerComponent],
})
export class AppStoredFileManagerComponent implements OnInit {
  private storageApiService = inject(StorageApiService);
  private resultService = inject(ResultService);

  storages = signal<ExplorerStorage[]>([]);

  ngOnInit(): void {
    this.loadStorages();
  }

  /** Recarrega os discos; também chamado quando o explorador altera o espaço ocupado (upload/exclusão). */
  loadStorages(): void {
    this.storageApiService.list().subscribe({
      next: (list) => this.storages.set(list ?? []),
      error: (error) => this.resultService.showError(error),
    });
  }
}
